<script lang="ts" setup>
import './modal.scss';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useModalsStore } from '@/stores/modals';
import { useUserStore } from '@/stores/user';
import { useSidebarStore } from '@/stores/sidebar';
import { useCamStore } from '@/stores/cam';
import { storeToRefs } from 'pinia';
import config from '@/config';

import { getStaticImages } from '@/utils';

const { modals, hasActiveModals, getActiveModal } = storeToRefs(useModalsStore());
const { getModal, closeModal } = useModalsStore();
const userStore = useUserStore();
const camStore = useCamStore();
const sidebar = useSidebarStore();
const route = useRoute();

const isSubmitting = ref(false);

function loadLoader(status: boolean){
    isSubmitting.value = status;
}

const currentModal = computed(() => {
    return config.Themename && config.Themename !== 'thuis' && getActiveModal.value === 'cookiee' ? 'cookiee-dark' : getActiveModal.value;
});

const sidebarAdjustment = computed(() => {
    return route.name === 'videochat' && sidebar.bodyWidth as any > 992 ? true : false;
});

</script>

<template src="./modal.html"></template>